import React, { useMemo } from 'react';
import moment from 'moment';
import CalendarPeriodCells from './CalendarPeriodCells';
import { buildMonthGrid, getWeekdayNames, isOutOfRange, isSameDay } from '../../../utils/calendar';

const getDayKey = (day) => moment(day.date).format('YYYY-MM-DD');

const CalendarDays = ({ viewDate, selected, minDate, maxDate, locale, onSelect }) => {
  const days = useMemo(() => buildMonthGrid(viewDate), [viewDate]);
  const weekdayNames = useMemo(() => getWeekdayNames(locale), [locale]);
  const today = new Date();

  return (
    <CalendarPeriodCells
      items={days}
      getKey={getDayKey}
      getValue={(day) => day.date}
      getLabel={(day) => day.date.getDate()}
      getTestId={(day) => `calendar-day-${getDayKey(day)}`}
      getExtra={(day) => [`calendar-day-${getDayKey(day)}`, day.inMonth ? '' : 'is-outside']}
      isCurrent={(day) => isSameDay(day.date, today)}
      isPicked={(day) => isSameDay(day.date, selected)}
      isDisabled={(day) => isOutOfRange(day.date, minDate, maxDate)}
      onPick={onSelect}
      gridClassName="te-calendar-grid"
      cellClassName="te-calendar-day"
    >
      {weekdayNames.map((name) => (
        <span key={name} className="te-calendar-weekday">
          {name}
        </span>
      ))}
    </CalendarPeriodCells>
  );
};

export default CalendarDays;
